<template>
   <comBox>
     <template v-slot:name>
       <h4>{{$store.state.module1.isChina?'室内空气质量指数':'Indoor Air Quality'}}(IHAI)</h4>
     </template>
     <template v-slot:content>
       <div class="pointer-parent" ref="er">
         <div id="pointer">
         </div>
         <p style="position:relative;"><i class="el-icon-warning-outline"></i>{{$store.state.module1.isChina?'室内空气质量指数':'Indoor Air Quality'}}<water type='ihai' :num='ihai * 100' style="position:absolute;left:70%;top:-200%;zIndex:199;cursor:pointer;"></water></p>
       </div>
     </template>
   </comBox>
</template>

<script>
import water from '../water/water.vue'
import { Gauge } from '@antv/g2plot'
import comBox from '../comBox/comBox.vue'
export default {
  name: 'pointer',
  props: ['ihai'],
  components: {
    comBox,
    water
  },
  data () {
    return {
      gauge: null,
      rColor: '#F34D4E',
      wColors: ['#52DB75', '#FCBC05', '#FF8719', '#E25F5F', '#7A65DB', '#A33C6B'],
      showRant: false
    }
  },
  methods: {
    reM () {
      if (this.gauge) {
        this.gauge.destroy()
      }
    },
    upPoint () {
      this.gauge = new Gauge('pointer', {
        percent: this.ihai > 1 ? 1 : this.ihai,
        radius: 0.9,
        innerRadius: 0.85,
        tickLine: null,
        range: {
          color: this.rColor
        },
        axis: {
          label: {
            formatter (v) {
              return Number(v) * 100
            }
          },
          subTickLine: {
            count: 3
          }
        },
        statistic: {
          content: {
            formatter: ({ percent }) => `${parseInt(percent * 100)}`,
            color: 'black'
          }
        },
        indicator: {
          pointer: {
            style: {
              stroke: this.rColor
            }
          },
          pin: {
            style: {
              stroke: this.rColor
            }
          }
        }
      })
      this.gauge.render()
    }
  },
  watch: {
    ihai (value) {
      this.$nextTick(() => {
        this.reM()
        if (value * 100 >= 90) {
          this.rColor = this.wColors[0]
        } else if (value * 100 >= 75) {
          this.rColor = this.wColors[1]
        } else if (value * 100 >= 60) {
          this.rColor = this.wColors[2]
        } else if (value * 100 >= 50) {
          this.rColor = this.wColors[3]
        } else if (value === 0) {
          this.rColor = this.wColors[0]
        } else {
          this.rColor = this.wColors[4]
        }
        this.upPoint()
      })
    }
  }
}
</script>

<style lang='less' scoped>
#pointer{
  width:3.4rem;
  height:3.4rem;
  position:relative;
}
.pointer-parent{
  p{
    margin-top:0.2rem;
  }
}
.rant{
  position:absolute;
  z-index:200;
  left:90%;top:-400%;
  width:2rem;
  height:2.4rem;
}
</style>
